import React from "react";
import {useSelector} from "react-redux";
import RootState from "../../../redux/states/root.state";
import {SpaSettingsLabels} from "../../../mqttData/settings/spaSettingsLabels";
import { SpecGroup, SpecRow } from "./SpecGroup";

const NetworkCard: React.FC = () => {
    const settingsData = useSelector((state: RootState) => state.settings.data);

    const signalMapper = (signal: any) => {
        if (signal<=-80){
            return 'Very Poor'
        } else if (signal<=-70 && signal>-80) {
            return 'Weak'
        } else if (signal<=-60 && signal>-70) {
            return 'Fair'
        } else if (signal<=-50 && signal>-60) {
            return 'Good'
        } else if (signal>-50){
            return 'Excellent'
        }
        return null
    }

    const signalTone = (signal: any) => signal > -60 ? 'good' : signal > -70 ? 'caution' : 'bad';

  const signal = settingsData[SpaSettingsLabels.Signal_Strength];
  const stat = (key: string) => settingsData[key] ?? '-';

  return (
    <section className="sd-section sd-spec-section sd-net">
      {/* Same groups and order as the original layout, side by side */}
      <div className="sd-specs sd-specs-row">
        <SpecGroup>
          <SpecRow label="Eth/Wifi">{settingsData[SpaSettingsLabels.interface] ?? '-'}</SpecRow>
        </SpecGroup>
        <SpecGroup>
          <SpecRow label="Private IP" mono>{settingsData[SpaSettingsLabels.Private_IP] ?? '-'}</SpecRow>
          <SpecRow label="Public IP" mono>{settingsData[SpaSettingsLabels.Public_IP] ?? '-'}</SpecRow>
          <SpecRow label="MAC" mono>{settingsData[SpaSettingsLabels.MAC_Address] ?? '-'}</SpecRow>
        </SpecGroup>
        <SpecGroup>
          <SpecRow label="SSID">{settingsData[SpaSettingsLabels.SSID] ?? '-'}</SpecRow>
          <SpecRow label="Signal Strength">
            {signal ?? '-'}
            {signal && signalMapper(signal) && <span className={`sd-pill ${signalTone(signal)}`}>{signalMapper(signal)}</span>}
          </SpecRow>
          <SpecRow label="Connection Type">{settingsData[SpaSettingsLabels.Connection_Type] ?? '-'}</SpecRow>
        </SpecGroup>
        <SpecGroup>
          <SpecRow label="Rx Packets">{stat(SpaSettingsLabels.stats_rx_packets)}</SpecRow>
          <SpecRow label="Tx Packets">{stat(SpaSettingsLabels.stats_tx_packets)}</SpecRow>
        </SpecGroup>
        <SpecGroup>
          <SpecRow label="Rx Errors">{stat(SpaSettingsLabels.stats_rx_errors)}</SpecRow>
          <SpecRow label="Tx Errors">{stat(SpaSettingsLabels.stats_tx_errors)}</SpecRow>
        </SpecGroup>
        <SpecGroup>
          <SpecRow label="Rx Dropped">{stat(SpaSettingsLabels.stats_rx_dropped)}</SpecRow>
          <SpecRow label="Tx Dropped">{stat(SpaSettingsLabels.stats_tx_dropped)}</SpecRow>
        </SpecGroup>
        <SpecGroup>
          <SpecRow label="Rx Bytes">{stat(SpaSettingsLabels.stats_rx_bytes)}</SpecRow>
          <SpecRow label="Tx Bytes">{stat(SpaSettingsLabels.stats_tx_bytes)}</SpecRow>
        </SpecGroup>
        <SpecGroup>
          <SpecRow label="Storage">{settingsData?.storage_info?.size ?? '-'}</SpecRow>
          <SpecRow label="Used">{`${settingsData?.storage_info?.used ?? '-'} (${settingsData?.storage_info?.use_percent ?? '-'})`}</SpecRow>
          <SpecRow label="Available">{settingsData?.storage_info?.available ?? '-'}</SpecRow>
        </SpecGroup>
      </div>
    </section>
  );
};

export default NetworkCard;
